import React from 'react';

import NewTasksList from './NewTasksList';
import RightSidebarSearchForm from '../_earnMoneyCommon/RightSidebarSearchForm';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import GroupsSearchCollector from '../../../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchCollector';
import groupsSearchItem from '../../../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchItem';

const GroupsSearchItem = groupsSearchItem(NewTasksList);
const Content = ColumnsContent(
  GroupsSearchCollector(props => (
    <GroupsSearchItem
      {...props}
      groupName="newTasksList"
      listReduceName="tasksModule.lists.tasksListNewTasks"
    />
  )),
  () => (
    <RightSidebarSearchForm listReduceName="tasksModule.lists.tasksListNewTasks" />
  )
);

export default props => <Content {...props} />;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/NewTasksList/index.js